import { DataBox, createDataBox } from 'app/common/data-box-store'


export type Date = string


class DateFilterDataBox extends DataBox<Date> { }

export const defaultDate: Date = ''
export const dateFilter = createDataBox('dateFilter', defaultDate, DateFilterDataBox)
